import Cookies from "js-cookie";
import clevertap from "clevertap-web-sdk";

const cleverTapTracking = ({
  userData,
  isClient = true,
  pageName,
  extra_params = {},
  environment="PROD",
}) => {
  if (
    userData &&
    isClient &&
    userData.recruiter_id &&
    typeof window !== "undefined"
  ) {
    // const getSessionId = () => {
    //   if (window.sessionStorage) {
    //     return sessionStorage.getItem("SESSION_STORAGE_SUBUID");
    //   }
    //   return Cookies.get("SESSION_STORAGE_SUBUID") || null;
    // };

    // const storeSessionId = (sessionId) => {
    //   if (window.sessionStorage) {
    //     sessionStorage.setItem("SESSION_STORAGE_SUBUID", sessionId);
    //   }
    //   Cookies.set("SESSION_STORAGE_SUBUID", sessionId, { expires: 1 });
    // };

    // Initialize CleverTap if not already initialized
    const ctKey = environment === "PROD" ? "844-RZ9-9Z7Z" : "TEST-944-RZ9-9Z7Z";
    if (!window.clevertapInitialized) {
    clevertap.init(ctKey, "in1");
    clevertap.privacy.push({ optOut: false });
    clevertap.privacy.push({ useIP: true });
      window.clevertapInitialized = true; // Prevent multiple initializations
    }

    const sessionKey = "CLEVERTAP_PAGE_TRACKING";

const getTrackedPages = () => {
  if (window.sessionStorage) {
    const storedData = sessionStorage.getItem(sessionKey);
    return storedData ? JSON.parse(storedData) : [];
  }
  return [];
};

const storeTrackedPage = (entry) => {
  if (window.sessionStorage) {
    const trackedPages = getTrackedPages();
    if (!trackedPages.includes(entry)) {
      trackedPages.push(entry);
      sessionStorage.setItem(sessionKey, JSON.stringify(trackedPages));
    }
  }
};

const shouldTrackPage = (entry) => !getTrackedPages().includes(entry);

// Generate the unique key for tracking
const sessionEntry = `${userData.recruiter_id}_${pageName}`;

if (userData.recruiter_id && shouldTrackPage(sessionEntry)) {
  clevertap.onUserLogin.push({
    Site: {
      Identity: userData.recruiter_id,
      xcode: userData.x_code,
      subuid: userData.recruiter_id,
    },
  });

  console.log("Event login pushed");
  storeTrackedPage(sessionEntry);
}
    if (
      userData.recruiter_id
    ) {
    clevertap.profile.push({
      Site: {
        xcode: userData.x_code,
        subuid: userData.recruiter_id,
      },
    });
  }
  if (
    userData.recruiter_id
  ) {
   
      clevertap.event.push("page_view", {
        page_name: pageName,
        subuid: userData.recruiter_id,
        corp_id: userData.corp_id,
        channel_Id: userData.channel_id,
        xcode: userData.x_code,
        company_name: userData.company_name,
        session_id: userData.tracking_id,
        time_stamp: new Date().getTime(),
        ...extra_params,
      });
    
  }
    console.log("CleverTap initialized successfully");
  }
};

export default cleverTapTracking;